"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircularChart = void 0;
const react_1 = __importDefault(require("react"));
const helpers_1 = require("../../../helpers");
const constants_1 = require("../constants");
const helpers_2 = require("../helpers");
const Legends_1 = require("../Legends");
const types_1 = require("./types");
const CircularChart = ({ isRimShown = true, total, totalLabel, color, totalDifference, totalSuffix, value, legendRenderer, legendType, scale = 1, isTrendHidden, isFloor, }) => {
    if (!Array.isArray(value)) {
        value = [value];
    }
    const svgSize = Math.round(scale * 60);
    const strokeWidth = Math.round(scale * 3);
    const radius = Math.round((svgSize - strokeWidth - 1) / 2);
    const center = Math.round(svgSize / 2);
    const rimRadius = radius;
    const sumValues = value.reduce((a, v) => a + v, 0);
    const isEqualityTotalAndSumValues = typeof total === 'number' && value.length <= 1 ? total > sumValues : sumValues === total;
    const totalValue = typeof total === 'number' && isEqualityTotalAndSumValues ? total : sumValues;
    let angles = [];
    if (totalValue) {
        value.reduce((a, v) => {
            const part = isFloor ? Math.trunc((v / totalValue) * 100) / 100 : v / totalValue;
            let vAngle = part * 2 * Math.PI;
            // prevent issues of 2Pi angle (100% of circle). if angle will be equal 2Pi, no arc will be drawn, but in this case (below)all should be ok
            if (vAngle >= 2 * Math.PI - 0.001) {
                vAngle = 2 * Math.PI - 0.001;
            }
            const angle = a + vAngle;
            angles.push(angle);
            return angle;
        }, 0);
    }
    const paths = angles.map((angle, idx) => {
        const colorIndex = helpers_2.calcColorIndex(idx, angles.length, constants_1.ChartColors.length);
        const startAng = !idx ? 0 : angles[idx - 1];
        const d = helpers_2.arc(center, radius, startAng, angle);
        return (react_1.default.createElement("path", { key: helpers_1.hashCode(`${angle}`), fill: "none", stroke: color || constants_1.ChartColors[colorIndex], strokeWidth: strokeWidth, d: d }));
    });
    let legend = null;
    const percentageValue = (100 * sumValues) / totalValue;
    const percentageDifference = 100 - Number(percentageValue.toFixed(3));
    const formatPercentageValue = isFloor || percentageDifference < 0.5
        ? Math.floor(percentageValue)
        : Math.round(percentageValue);
    switch (legendType) {
        case types_1.CHART_LEGEND_TYPE.percent:
            legend = (react_1.default.createElement(Legends_1.PercentCircularLegend, { size: svgSize, text: totalValue ? `${formatPercentageValue}%` : '0%' }));
            break;
        case types_1.CHART_LEGEND_TYPE.total:
            legend = (react_1.default.createElement(Legends_1.TotalCircularLegend, { size: svgSize, totalText: sumValues === total ? `${total}` : `${Math.round(sumValues)}`, totalLabel: totalLabel, suffix: totalSuffix, difference: totalDifference, isTrendHidden: isTrendHidden }));
            break;
        case types_1.CHART_LEGEND_TYPE.custom:
            if (legendRenderer) {
                legend = legendRenderer(svgSize, value, totalValue, totalDifference, totalSuffix);
            }
            break;
    }
    // necessary double wrap <svg/> into <div/> because svg tag gives margins
    return (react_1.default.createElement("div", { style: { width: svgSize, height: svgSize } },
        react_1.default.createElement("div", { style: { width: svgSize, height: svgSize, overflow: 'hidden' } },
            react_1.default.createElement("svg", { width: svgSize, height: svgSize },
                isRimShown && (react_1.default.createElement("path", { fill: "none", stroke: constants_1.AllChartColors.rim, strokeWidth: 1, d: helpers_2.arc(center, rimRadius, 0.001, 2 * Math.PI) })),
                paths)),
        legend));
};
exports.CircularChart = CircularChart;
//# sourceMappingURL=CircularChart.js.map